module.exports = __webpack_public_path__ + "static/media/plus-square-white.099ad952.svg";